import HttpClient from "@/api/utils/HttpClient"
import { requestMiddleware } from "../utils/requestMiddleware"

export const newsfeedApiClient = HttpClient({
  baseURL: import.meta.env.SO_NEWSFEED_API_URL,
  responseType: "json",
})

const interceptor = requestMiddleware.createRestInterceptor()

newsfeedApiClient.interceptors.request.use(interceptor.request)
newsfeedApiClient.interceptors.response.use(
  interceptor.response,
  interceptor.responseError,
)
